import React from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';
import { Store, Plus } from 'lucide-react';
import './Estabelecimentos.css';

const Estabelecimentos = () => {
  const { data, isLoading } = useQuery(
    'estabelecimentos',
    async () => {
      const response = await api.get('/api/estabelecimentos');
      return response.data.data.estabelecimentos;
    }
  );

  if (isLoading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div className="estabelecimentos">
      <div className="page-header">
        <h2>Estabelecimentos</h2>
        <button className="btn btn-primary">
          <Plus size={20} />
          Novo Estabelecimento
        </button>
      </div>

      <div className="estabelecimentos-grid">
        {data?.map((estabelecimento) => (
          <div key={estabelecimento._id} className="estabelecimento-card">
            <div className="estabelecimento-header">
              <Store size={24} />
              <h3>{estabelecimento.nome}</h3>
            </div>
            <div className="estabelecimento-info">
              <p><strong>CNPJ:</strong> {estabelecimento.cnpj}</p>
              <p><strong>Cidade:</strong> {estabelecimento.endereco?.cidade}</p>
              <p><strong>Status:</strong> 
                <span className={estabelecimento.ativo ? 'status-active' : 'status-inactive'}>
                  {estabelecimento.ativo ? ' Ativo' : ' Inativo'}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Estabelecimentos;

